
import { DevicesResponse, RfCodesResponse } from '@gtpl/shared-models/canteen-management';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { DevicesService } from './devices.service';
import { DevicesDto, RfCodeCreateRequest } from './dto';

@ApiTags('devices')
@Controller('devices')
export class DevicesController {
    constructor(
        private deviceService: DevicesService,
        private applicationExceptionHandler: ApplicationExceptionHandler
    ) { }
    /**
     * creates the rf code
     * @param rfCodeCreateReq 
     * @returns 
     */

    @Post('/createRfCode')
    async createRfCode(@Body() rfCodeCreateReq: RfCodeCreateRequest): Promise<RfCodesResponse> {
        try {
            return await this.deviceService.createRfCode(rfCodeCreateReq);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(RfCodesResponse, error);
        }
    }

    @Post('/createDevices')
    async createDevices(@Body() devicesDto:DevicesDto): Promise<DevicesResponse>{
        try{
            return await this.deviceService.createDevices(devicesDto);
        } catch (error){
            console.log('--------',devicesDto)
            console.log('errorrrr',error)
            return  this.applicationExceptionHandler.returnException(DevicesResponse,error);
        }
    }

    /**
     * 
     * @param rfCodeCreateReq 
     * @returns 
     */
    @Post('/deleteRfCode')
    async deleteRfCode(@Body() rfCodeCreateReq: RfCodeCreateRequest): Promise<RfCodesResponse> {
        try {
            return await this.deviceService.deleteRfCode(rfCodeCreateReq);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(RfCodesResponse, error);
        }
    }

    @Post('/deleteDevices')
    async deleteDevices(@Body() devicesDto:DevicesDto): Promise<DevicesResponse>{
        try{
            return await this.deviceService.deleteDevices(devicesDto);
        }catch(error){
            return  this.applicationExceptionHandler.returnException(DevicesResponse,error);
        }
        
    }

    @Post('/getAllRfCode')
    async getAllRfCode():Promise<RfCodesResponse>{
        try{
            return await this.deviceService.getAllRfCode();
        }catch(error){
            return this.applicationExceptionHandler.returnException(RfCodesResponse,error);
        }
    }

    @Post('/getAllDevices')
    async getAllDevices():Promise<DevicesResponse>{
        try{
            return await this.deviceService.getAllDevices();
        }catch(error){
            return  this.applicationExceptionHandler.returnException(DevicesResponse , error);
        }
    }

    /**
     * 
     * @param rfCodeCreateReq 
     * @returns 
     */
    @Post('/getRfCodeRecordByRfCode')
    async getRfCodeRecordByRfCode(@Body() rfCodeCreateReq: RfCodeCreateRequest): Promise<RfCodesResponse> {
        try {
            return await this.deviceService.getRfCodeRecordByRfCode(rfCodeCreateReq);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(RfCodesResponse, error);
        }
    }


}
